import { useQuery } from '@tanstack/react-query';

import { getSharesAvailableForUser } from '@arrived/api_v2';
import { OfferingId, TotalAvailableSharesResponse } from '@arrived/models';

import { UseQueryOptions } from '../queries.utils';
import { useGetCurrentUserQuery } from '../users';
import { userSharesAvailableKeyFn } from './sharesAvailable.keys';

export function useSharesAvailableForUserQuery(
  offeringId?: OfferingId,
  options?: UseQueryOptions<TotalAvailableSharesResponse>
) {
  const { data } = useGetCurrentUserQuery();
  const userId = data?.id;

  return useQuery(
    userSharesAvailableKeyFn(offeringId!, userId!),
    async () => getSharesAvailableForUser(userId!, offeringId!),
    {
      ...options,
      staleTime: options?.staleTime ?? 10_000,
      enabled: (options?.enabled ?? true) && offeringId != null && userId != null,
    }
  );
}
